import { render, staticRenderFns } from "./DepositView.vue?vue&type=template&id=473f7b6d"
import script from "./DepositView.vue?vue&type=script&lang=js"
export * from "./DepositView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports